const MAX_RESTAURANTS_PER_ADDRESS = 8;

const isEditionsTag = (tag) => tag.name === 'Deliveroo Editions';
const offerTag = (tag) => (tag ? tag.name : undefined);

const tagsHaveSearchTerm = (restaurant, searchTerm) =>
  restaurant.menu_tags.some((tag) => tag.name.toLowerCase().includes(searchTerm));

const hasSearchTerm = (restaurant, searchTerm) => {
  if (!searchTerm) return true;

  const restaurantNameLowerCase = restaurant.name.toLowerCase();
  const searchTermLowerCase = searchTerm.toLowerCase();

  const restaurantNameMatch = restaurantNameLowerCase.includes(searchTermLowerCase);
  const tagMatch = tagsHaveSearchTerm(restaurant, searchTermLowerCase);

  return restaurantNameMatch || tagMatch;
};

export const isAddressInCity = (address, city) => !city || city === address.city;

export const createRestaurant = (result) => {
  const isRestaurantEstimated = result.delivery_time_units === 'restaurant_estimated';
  const deliveryTime = {
    qualifier: isRestaurantEstimated ? 'around' : 'mins',
    qualifierPosition: isRestaurantEstimated ? 'BEFORE' : undefined,
    text: result.delivery_time,
  };

  return {
    id: result.id,
    categoryNames: result.menu_tags ? result.menu_tags.map((tag) => tag.name) : [],
    deliveryStatus: result.delivery_status,
    deliveryTime,
    imageUrl: result.image_url,
    isEditions: result.menu_tags ? Boolean(result.menu_tags.some(isEditionsTag)) : false,
    menuTags: result.menu_tags ? result.menu_tags : [],
    name: result.name,
    offer: offerTag(result.offers && result.offers.find((tag) => !isEditionsTag(tag))),
    priceCategory: result.price_category_symbol,
    ratingCount: result.rating_formatted_count,
    ratingPercent: result.rating_percentage,
    url: result.links ? result.links.web : undefined,
  };
};

export const createRestaurantsForCuisine = (restaurants = [], cuisine) =>
  restaurants
    .filter((result) => result.type === 'restaurant')
    .filter((restaurant) => hasSearchTerm(restaurant, cuisine))
    .slice(0, MAX_RESTAURANTS_PER_ADDRESS)
    .map(createRestaurant);
